import $ from 'jquery';

const skipEventOnUrlsWith = [
    'blsstaging.brooklaw.edu',
    'www.brooklaw.edu',
    'newbls.brooklaw.edu',
    'localhost'
];
export default class LinkTracker {

    constructor($el) {
        //ensure dataLayer is initialized
        window.dataLayer = window.dataLayer || [];
        this.$el = $el;
        this.$el.click(this.clickEventHandler.bind(this));

    }
    gtag() {
        window.dataLayer.push(arguments);
    }
    clickEventHandler(e) {
        const link = $(e.target).closest('a');
        if (link.length !== 1 ||
            e.isDefaultPrevented()) {
            return;
        }
        const hostOfLink = link[0].host;
        if (this.shouldSkipLink(hostOfLink)) {
            return;
        }
        const href = link[0].href;
        this.gtag('event',
            'click', {
                'event_category': 'outbound_link',
                'event_label': href
            });
    }
    shouldSkipLink(hostUrl) {
        return !hostUrl ||
            hostUrl === window.location.host ||
            skipEventOnUrlsWith.some((l) => hostUrl.includes(l));
    }
}
